// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pageHighlightContainer{padding-top:5px}.pageHighlightParagraph{line-height:0px}.search-result-text{display:flex;flex-direction:column}", ""]);
// Exports
module.exports = exports;
